'use strict';

/**
 * Filter Dynamic - Used for filterable table.
 *
 * @author Matthias Giger <matthias.giger@namics.com>
 */
T.Module.FilterDynamic = T.createModule({

	_selectors: {
		picker: '[data-js-m-filter-dynamic__picker]',
		input: '.a-filter-dropdown__input'
	},

	_stateClasses: {
		open: 'state-open'
	},

	_eventNames: {
		filterChange: 'm-filterable-table__filter-change'
	},

	start: function start(resolve) {
		this.$ctx = $(this._ctx);

		// References
		this.$input = this.$ctx.find(this._selectors.input);
		this.$picker = this.$ctx.find(this._selectors.picker);

		// Component Event Binding
		this.$picker.click(this.$onPickerClick.bind(this));
		this.$input.change(this.$onInputChange.bind(this));

		resolve();
	},


	/**
  * On mobile shows the filters.
  *
  * @returns {undefined} void
  **/
	$onPickerClick: function $onPickerClick() {
		this.$ctx.toggleClass(this._stateClasses.open);
	},


	/**
  * Sends an event to the filterable table when a value is chosen.
  *
  * @param {Event} event The event
  * @returns {undefined} void
  **/
	$onInputChange: function $onInputChange(event) {
		var value = $(event.target).val();
		var columnIndex = $(event.target).attr('id');

		this._events.emit(this._eventNames.filterChange, columnIndex, value);
	}
});